// This script is autogenerated by genlocale.py; do not edit by hand.

interface LocaleInfo {
  name: string;
  weekdays: {
    short: string[];
    wide: string[];
    abbreviated: string[];
    narrow: string[];
  };
}

const localeData: Record<string, LocaleInfo> = {
  ar: {
    name: "Arabic",
    weekdays: {
      abbreviated: [
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت",
        "الأحد",
      ],
      narrow: ["ن", "ث", "ر", "خ", "ج", "س", "ح"],
      short: ["إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت", "أحد"],
      wide: [
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت",
        "الأحد",
      ],
    },
  },
  bg: {
    name: "Bulgarian",
    weekdays: {
      abbreviated: ["пн", "вт", "ср", "чт", "пт", "сб", "нд"],
      narrow: ["п", "в", "с", "ч", "п", "с", "н"],
      short: ["пн", "вт", "ср", "чт", "пт", "сб", "нд"],
      wide: [
        "понеделник",
        "вторник",
        "сряда",
        "четвъртък",
        "петък",
        "събота",
        "неделя",
      ],
    },
  },
  bs: {
    name: "Bosnian",
    weekdays: {
      abbreviated: ["pon", "uto", "sri", "čet", "pet", "sub", "ned"],
      narrow: ["p", "u", "s", "č", "p", "s", "n"],
      short: ["pon", "uto", "sri", "čet", "pet", "sub", "ned"],
      wide: [
        "ponedjeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota",
        "nedjelja",
      ],
    },
  },
  ca: {
    name: "Catalan",
    weekdays: {
      abbreviated: ["dl.", "dt.", "dc.", "dj.", "dv.", "ds.", "dg."],
      narrow: ["dl", "dt", "dc", "dj", "dv", "ds", "dg"],
      short: ["dl.", "dt.", "dc.", "dj.", "dv.", "ds.", "dg."],
      wide: [
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte",
        "diumenge",
      ],
    },
  },
  cs: {
    name: "Czech",
    weekdays: {
      abbreviated: ["po", "út", "st", "čt", "pá", "so", "ne"],
      narrow: ["P", "Ú", "S", "Č", "P", "S", "N"],
      short: ["po", "út", "st", "čt", "pá", "so", "ne"],
      wide: [
        "pondělí",
        "úterý",
        "středa",
        "čtvrtek",
        "pátek",
        "sobota",
        "neděle",
      ],
    },
  },
  da: {
    name: "Danish",
    weekdays: {
      abbreviated: ["man", "tir", "ons", "tor", "fre", "lør", "søn"],
      narrow: ["M", "T", "O", "T", "F", "L", "S"],
      short: ["ma", "ti", "on", "to", "fr", "lø", "sø"],
      wide: [
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lørdag",
        "søndag",
      ],
    },
  },
  de: {
    name: "German",
    weekdays: {
      abbreviated: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
      narrow: ["M", "D", "M", "D", "F", "S", "S"],
      short: ["Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa.", "So."],
      wide: [
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
        "Sonntag",
      ],
    },
  },
  el: {
    name: "Greek",
    weekdays: {
      abbreviated: ["Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ", "Κυρ"],
      narrow: ["Δ", "Τ", "Τ", "Π", "Π", "Σ", "Κ"],
      short: ["Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά", "Κυ"],
      wide: [
        "Δευτέρα",
        "Τρίτη",
        "Τετάρτη",
        "Πέμπτη",
        "Παρασκευή",
        "Σάββατο",
        "Κυριακή",
      ],
    },
  },
  en: {
    name: "English",
    weekdays: {
      abbreviated: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      narrow: ["M", "T", "W", "T", "F", "S", "S"],
      short: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
      wide: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    },
  },
  es: {
    name: "Spanish",
    weekdays: {
      abbreviated: ["lun.", "mar.", "mié.", "jue.", "vie.", "sáb.", "dom."],
      narrow: ["L", "M", "X", "J", "V", "S", "D"],
      short: ["LU", "MA", "MI", "JU", "VI", "SA", "DO"],
      wide: [
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
        "domingo",
      ],
    },
  },
  et: {
    name: "Estonian",
    weekdays: {
      abbreviated: ["E", "T", "K", "N", "R", "L", "P"],
      narrow: ["E", "T", "K", "N", "R", "L", "P"],
      short: ["E", "T", "K", "N", "R", "L", "P"],
      wide: [
        "esmaspäev",
        "teisipäev",
        "kolmapäev",
        "neljapäev",
        "reede",
        "laupäev",
        "pühapäev",
      ],
    },
  },
  fa: {
    name: "Persian",
    weekdays: {
      abbreviated: [
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنجشنبه",
        "جمعه",
        "شنبه",
        "یکشنبه",
      ],
      narrow: ["د", "س", "چ", "پ", "ج", "ش", "ی"],
      short: ["۲ش", "۳ش", "۴ش", "۵ش", "ج", "ش", "۱ش"],
      wide: [
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنجشنبه",
        "جمعه",
        "شنبه",
        "یکشنبه",
      ],
    },
  },
  fi: {
    name: "Finnish",
    weekdays: {
      abbreviated: ["ma", "ti", "ke", "to", "pe", "la", "su"],
      narrow: ["M", "T", "K", "T", "P", "L", "S"],
      short: ["ma", "ti", "ke", "to", "pe", "la", "su"],
      wide: [
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai",
        "sunnuntai",
      ],
    },
  },
  fr: {
    name: "French",
    weekdays: {
      abbreviated: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
      narrow: ["L", "M", "M", "J", "V", "S", "D"],
      short: ["lu", "ma", "me", "je", "ve", "sa", "di"],
      wide: [
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi",
        "dimanche",
      ],
    },
  },
  gl: {
    name: "Galician",
    weekdays: {
      abbreviated: ["Luns", "Mar.", "Mér.", "Xov.", "Ven.", "Sáb.", "Dom."],
      narrow: ["L", "M", "M", "X", "V", "S", "D"],
      short: ["Lu", "Ma", "Mé", "Xo", "Ve", "Sá", "Do"],
      wide: [
        "Luns",
        "Martes",
        "Mércores",
        "Xoves",
        "Venres",
        "Sábado",
        "Domingo",
      ],
    },
  },
  he: {
    name: "Hebrew",
    weekdays: {
      abbreviated: [
        "יום ב׳",
        "יום ג׳",
        "יום ד׳",
        "יום ה׳",
        "יום ו׳",
        "שבת",
        "יום א׳",
      ],
      narrow: ["ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳", "א׳"],
      short: ["ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳", "א׳"],
      wide: [
        "יום שני",
        "יום שלישי",
        "יום רביעי",
        "יום חמישי",
        "יום שישי",
        "יום שבת",
        "יום ראשון",
      ],
    },
  },
  hu: {
    name: "Hungarian",
    weekdays: {
      abbreviated: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      narrow: ["H", "K", "Sz", "Cs", "P", "Sz", "V"],
      short: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      wide: [
        "hétfő",
        "kedd",
        "szerda",
        "csütörtök",
        "péntek",
        "szombat",
        "vasárnap",
      ],
    },
  },
  id: {
    name: "Indonesian",
    weekdays: {
      abbreviated: ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"],
      narrow: ["S", "S", "R", "K", "J", "S", "M"],
      short: ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"],
      wide: ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"],
    },
  },
  is: {
    name: "Icelandic",
    weekdays: {
      abbreviated: ["mán.", "þri.", "mið.", "fim.", "fös.", "lau.", "sun."],
      narrow: ["M", "Þ", "M", "F", "F", "L", "S"],
      short: ["má.", "þr.", "mi.", "fi.", "fö.", "la.", "su."],
      wide: [
        "mánudagur",
        "þriðjudagur",
        "miðvikudagur",
        "fimmtudagur",
        "föstudagur",
        "laugardagur",
        "sunnudagur",
      ],
    },
  },
  it: {
    name: "Italian",
    weekdays: {
      abbreviated: ["lun", "mar", "mer", "gio", "ven", "sab", "dom"],
      narrow: ["L", "M", "M", "G", "V", "S", "D"],
      short: ["lun", "mar", "mer", "gio", "ven", "sab", "dom"],
      wide: [
        "lunedì",
        "martedì",
        "mercoledì",
        "giovedì",
        "venerdì",
        "sabato",
        "domenica",
      ],
    },
  },
  ja: {
    name: "Japanese",
    weekdays: {
      abbreviated: ["月", "火", "水", "木", "金", "土", "日"],
      narrow: ["月", "火", "水", "木", "金", "土", "日"],
      short: ["月", "火", "水", "木", "金", "土", "日"],
      wide: [
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日",
        "日曜日",
      ],
    },
  },
  km: {
    name: "Khmer",
    weekdays: {
      abbreviated: [
        "ចន្ទ",
        "អង្គារ",
        "ពុធ",
        "ព្រហ",
        "សុក្រ",
        "សៅរ៍",
        "អាទិត្យ",
      ],
      narrow: ["ច", "អ", "ព", "ព", "ស", "ស", "អ"],
      short: ["ច", "អ", "ពុ", "ព្រ", "សុ", "ស", "អា"],
      wide: ["ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍", "អាទិត្យ"],
    },
  },
  ko: {
    name: "Korean",
    weekdays: {
      abbreviated: ["월", "화", "수", "목", "금", "토", "일"],
      narrow: ["월", "화", "수", "목", "금", "토", "일"],
      short: ["월", "화", "수", "목", "금", "토", "일"],
      wide: [
        "월요일",
        "화요일",
        "수요일",
        "목요일",
        "금요일",
        "토요일",
        "일요일",
      ],
    },
  },
  lt: {
    name: "Lithuanian",
    weekdays: {
      abbreviated: ["pr", "an", "tr", "kt", "pn", "št", "sk"],
      narrow: ["P", "A", "T", "K", "P", "Š", "S"],
      short: ["Pr", "An", "Tr", "Kt", "Pn", "Št", "Sk"],
      wide: [
        "pirmadienis",
        "antradienis",
        "trečiadienis",
        "ketvirtadienis",
        "penktadienis",
        "šeštadienis",
        "sekmadienis",
      ],
    },
  },
  lv: {
    name: "Latvian",
    weekdays: {
      abbreviated: [
        "Pirmd.",
        "Otrd.",
        "Trešd.",
        "Ceturtd.",
        "Piektd.",
        "Sestd.",
        "Svētd.",
      ],
      narrow: ["P", "O", "T", "C", "P", "S", "S"],
      short: ["Pr", "Ot", "Tr", "Ce", "Pk", "Se", "Sv"],
      wide: [
        "Pirmdiena",
        "Otrdiena",
        "Trešdiena",
        "Ceturtdiena",
        "Piektdiena",
        "Sestdiena",
        "Svētdiena",
      ],
    },
  },
  mk: {
    name: "Macedonian",
    weekdays: {
      abbreviated: ["пон.", "вто.", "сре.", "чет.", "пет.", "саб.", "нед."],
      narrow: ["п", "в", "с", "ч", "п", "с", "н"],
      short: ["пон.", "вто.", "сре.", "чет.", "пет.", "саб.", "нед."],
      wide: [
        "понеделник",
        "вторник",
        "среда",
        "четврток",
        "петок",
        "сабота",
        "недела",
      ],
    },
  },
  nl: {
    name: "Dutch",
    weekdays: {
      abbreviated: ["ma", "di", "wo", "do", "vr", "za", "zo"],
      narrow: ["M", "D", "W", "D", "V", "Z", "Z"],
      short: ["ma", "di", "wo", "do", "vr", "za", "zo"],
      wide: [
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag",
        "zondag",
      ],
    },
  },
  nn: {
    name: "Norwegian Nynorsk",
    weekdays: {
      abbreviated: ["mån", "tys", "ons", "tor", "fre", "lau", "søn"],
      narrow: ["M", "T", "O", "T", "F", "L", "S"],
      short: ["må.", "ty.", "on.", "to.", "fr.", "la.", "sø."],
      wide: [
        "måndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag",
        "søndag",
      ],
    },
  },
  no: {
    name: "Norwegian Bokmål (Norway)",
    weekdays: {
      abbreviated: ["man.", "tir.", "ons.", "tor.", "fre.", "lør.", "søn."],
      narrow: ["M", "T", "O", "T", "F", "L", "S"],
      short: ["ma.", "ti.", "on.", "to.", "fr.", "lø.", "sø."],
      wide: [
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lørdag",
        "søndag",
      ],
    },
  },
  pl: {
    name: "Polish",
    weekdays: {
      abbreviated: ["pon.", "wt.", "śr.", "czw.", "pt.", "sob.", "niedz."],
      narrow: ["P", "W", "Ś", "C", "P", "S", "N"],
      short: ["pon", "wto", "śro", "czw", "pią", "sob", "nie"],
      wide: [
        "poniedziałek",
        "wtorek",
        "środa",
        "czwartek",
        "piątek",
        "sobota",
        "niedziela",
      ],
    },
  },
  pt: {
    name: "Portuguese",
    weekdays: {
      abbreviated: ["seg.", "ter.", "qua.", "qui.", "sex.", "sáb.", "dom."],
      narrow: ["S", "T", "Q", "Q", "S", "S", "D"],
      short: ["seg.", "ter.", "qua.", "qui.", "sex.", "sáb.", "dom."],
      wide: [
        "segunda-feira",
        "terça-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "sábado",
        "domingo",
      ],
    },
  },
  ro: {
    name: "Romanian",
    weekdays: {
      abbreviated: ["lun.", "mar.", "mie.", "joi", "vin.", "sâm.", "dum."],
      narrow: ["L", "M", "M", "J", "V", "S", "D"],
      short: ["lu.", "ma.", "mi.", "joi", "vi.", "sâ.", "du."],
      wide: [
        "luni",
        "marți",
        "miercuri",
        "joi",
        "vineri",
        "sâmbătă",
        "duminică",
      ],
    },
  },
  ru: {
    name: "Russian",
    weekdays: {
      abbreviated: ["пн", "вт", "ср", "чт", "пт", "сб", "вс"],
      narrow: ["П", "В", "С", "Ч", "П", "С", "В"],
      short: ["пн", "вт", "ср", "чт", "пт", "сб", "вс"],
      wide: [
        "понедельник",
        "вторник",
        "среда",
        "четверг",
        "пятница",
        "суббота",
        "воскресенье",
      ],
    },
  },
  sk: {
    name: "Slovak",
    weekdays: {
      abbreviated: ["po", "ut", "st", "št", "pi", "so", "ne"],
      narrow: ["p", "u", "s", "š", "p", "s", "n"],
      short: ["po", "ut", "st", "št", "pi", "so", "ne"],
      wide: [
        "pondelok",
        "utorok",
        "streda",
        "štvrtok",
        "piatok",
        "sobota",
        "nedeľa",
      ],
    },
  },
  sl: {
    name: "Slovenian",
    weekdays: {
      abbreviated: ["pon.", "tor.", "sre.", "čet.", "pet.", "sob.", "ned."],
      narrow: ["p", "t", "s", "č", "p", "s", "n"],
      short: ["pon.", "tor.", "sre.", "čet.", "pet.", "sob.", "ned."],
      wide: [
        "ponedeljek",
        "torek",
        "sreda",
        "četrtek",
        "petek",
        "sobota",
        "nedelja",
      ],
    },
  },
  sv: {
    name: "Swedish",
    weekdays: {
      abbreviated: ["mån", "tis", "ons", "tors", "fre", "lör", "sön"],
      narrow: ["M", "T", "O", "T", "F", "L", "S"],
      short: ["må", "ti", "on", "to", "fr", "lö", "sö"],
      wide: [
        "måndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag",
        "söndag",
      ],
    },
  },
  th: {
    name: "Thai",
    weekdays: {
      abbreviated: ["จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส.", "อา."],
      narrow: ["จ", "อ", "พ", "พฤ", "ศ", "ส", "อา"],
      short: ["จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส.", "อา."],
      wide: [
        "วันจันทร์",
        "วันอังคาร",
        "วันพุธ",
        "วันพฤหัสบดี",
        "วันศุกร์",
        "วันเสาร์",
        "วันอาทิตย์",
      ],
    },
  },
  tr: {
    name: "Turkish",
    weekdays: {
      abbreviated: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
      narrow: ["P", "S", "Ç", "P", "C", "C", "P"],
      short: ["Pt", "Sa", "Ça", "Pe", "Cu", "Ct", "Pa"],
      wide: [
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
        "Pazar",
      ],
    },
  },
  uk: {
    name: "Ukrainian",
    weekdays: {
      abbreviated: ["пн", "вт", "ср", "чт", "пт", "сб", "нд"],
      narrow: ["П", "В", "С", "Ч", "П", "С", "Н"],
      short: ["пн", "вт", "ср", "чт", "пт", "сб", "нд"],
      wide: [
        "понеділок",
        "вівторок",
        "середа",
        "четвер",
        "пʼятниця",
        "субота",
        "неділя",
      ],
    },
  },
};
export const knownLocales = new Set([
  "ar",
  "bg",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "gl",
  "he",
  "hu",
  "id",
  "is",
  "it",
  "ja",
  "km",
  "ko",
  "lt",
  "lv",
  "mk",
  "nl",
  "nn",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "th",
  "tr",
  "uk",
]);

export default localeData;
